import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import { AmplifyAuthenticator, AmplifySignIn, AmplifyRequireNewPassword } from '@aws-amplify/ui-react';
// import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import RadioGroupQuestion from "components/RadioGroupQuestion";
import CheckboxQuestion from "components/CheckboxQuestion";
import DropdownQuestion from "components/DropdownQuestion";
import DataSelfie from "components/DataSelfie";
import DataSelfieLegend from "components/DataSelfieLegend";

import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { EyepieceThreeResponse } from "models";
// import { useHistory } from "react-router-dom";
// import { Route } from "react-router-dom";
import { Auth } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { DataStore } from "@aws-amplify/datastore";
import { generate } from "utils/ep3util";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
}));

function DataSelfieSurvey() {
  const classes = useStyles();
  let { school } = useParams();
  let [user, setUser] = useState();
  const [error, setError] = useState("");
  // const [submitted, setSubmitted] = useState(false);
  const [ip, setIp] = useState();
  const [response, setResponse] = useState();

  useEffect(async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();  
      console.log("user", user);
      setUser(user);
    }catch(err){
      console.log("user not authenticated", user);
    }
    
    

    const resp = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    const clientInfo = await resp.text();
    let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
    let ip = clientInfo.match(ipRegex)[0];
    console.log("client ip", ip);
    setIp(ip);

    const responses = await DataStore.query(EyepieceThreeResponse, (r) =>
    r.ip("eq", ip)
  );

    // check if already submitted
    console.log("submitted?", responses.length>0, responses);
    // setSubmitted(responses.length > 0);
    if (responses.length>0){
      setResponse(JSON.parse(responses[0].questions));
    }
    
  }, []);

  const [questions, setQuestions] = useState(generate());

  function handleSelectionChange(questionIndex, selected) {
    setQuestions(
      questions.map((q, i) => {
        if (i !== questionIndex) {
          return q;
        }
        return {
          ...q,
          selected,
        };
      })
    );
  }
  function handleCheckboxChange(questionIndex, optionIndex, checked) {
    setQuestions(
      questions.map((q, i) => {
        if (i !== questionIndex) {
          return q;
        }
        return {
          ...q,
          options: q.options.map((o, j) => {
            if (j !== optionIndex) {
              return o;
            }
            return {
              ...o,
              checked,
            };
          }),
        };
      })
    );
  }
  async function handleSubmit() {
    console.log("submitted", questions);
    const incomplete = questions.some((q) => {
      if (q.type === "checkbox") {
        return q.options.every((o) => !o.checked);
      }
      return q.selected === "";
    });
    if (incomplete) {
      setError("Please fill out every question.");
      return;
    }
    if (!school || !ip){
      setError("Something went wrong. Please contact the admin.");
    }
    setError("");
    const response = {
          ip: ip,
          school: school? school:undefined,
          username: user ? user.username : undefined,
          name: user ? user.attributes.name : undefined,
          email: user ? user.attributes.email : undefined,
          questions: JSON.stringify(questions),
        };
    console.log('response', response);
    await DataStore.save(
      new EyepieceThreeResponse(response)
    );
    setResponse(questions);
    // setSubmitted(true);
  }
  return (
    <Container maxWidth="md" className={classes.root}>
      {!school && (
        <Typography variant="body1" gutterBottom>
          The link is invalid.
        </Typography>
      )}
      {school  && (
        <Fragment>
          <Typography variant="h2" gutterBottom>
            Data Selfie Survey
          </Typography>
          <Typography variant="h5" gutterBottom>
          In the following questions, select the answer that best describes your school/community.
          </Typography>  
          <br/>
          <Typography variant="body1" gutterBottom>
            {user && user.attributes.name} (This is an anonymous survey)
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>{school}</strong>
          </Typography>
          
      
          
          {response && (
            <Fragment>
              <Box mt={5}>
              <Typography variant="h5" gutterBottom>
                Your Data Selfie
              </Typography>
              <DataSelfie response={response} school={school}/>
              
            </Box>
            <Box mt={5}>
              <Typography variant="h5" gutterBottom>
                Legend
              </Typography>
              <DataSelfieLegend response={response} />
            </Box>
              </Fragment>
          )}
          {!response && (
            <Box mb={10}>
              {questions.map((q, i) => {
                switch (q.type) {
                  case "radiogroup":
                    return (
                      <RadioGroupQuestion
                        key={i}
                        question={q.question}
                        options={q.options}
                        selected={q.selected}
                        onChange={handleSelectionChange.bind(this, i)}
                      />
                    );
                  case "checkbox":
                    return (
                      <CheckboxQuestion
                        key={i}
                        question={q.question}
                        options={q.options}
                        onChange={handleCheckboxChange.bind(this, i)}
                      />
                    );
                  case "dropdown":
                    return (
                      <DropdownQuestion
                        key={i}
                        question={q.question}
                        options={q.options}
                        selected={q.selected}
                        onChange={handleSelectionChange.bind(this, i)}
                      />
                    );
                }
              })}
              <Box p={3}>
                <Typography variant="subtitle1" color="error">
                  {error}
                </Typography>
              </Box>

              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.button}
                endIcon={<SendIcon />}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Box>
          )}
        </Fragment>
      )}
    </Container>
  );
}

export default DataSelfieSurvey;
